<div class="report-attribute-popup">
    <h2 class="m-b-5" mat-dialog-title>{{modalTitle}}</h2>
    <div mat-dialog-content>
        <app-attributes-loader></app-attributes-loader>
    </div>
    <div class="text-a-r  m-t-10 m-b-10">
        <button mat-raised-button color="accent" (click)="addAttribute()" class="m-r-15">Aceptar</button>
        <button mat-raised-button (click)="closePopup()" color="warn">Cancelar</button>
    </div>
</div>